import { useQuery } from '@apollo/client'
import { Table, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import dayjs from 'dayjs'
import { CHEQUES_QUERY } from '../../apollo/query/cheque.query'
import { D4_Cheque, D4_Partchequecoproprietaire } from '../../types'

const columns: ColumnsType<D4_Cheque> = [
  {
    title: 'Date',
    key: 'date',
    dataIndex: 'date',
    render: (_, record) => {
      if (record.bordereauderemisedecheque?.dateimpression) {
        return dayjs(record.bordereauderemisedecheque?.dateimpression).format('DD/MM/YYYY')
      }
      if (record.dateencaissementsouhaite) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            A partir du
            <Typography.Text mark>{dayjs(record.dateencaissementsouhaite).format('DD/MM/YYYY')}</Typography.Text>
          </div>
        )
      }
      return "En cours d'enregistrement"
    },
  },
  {
    title: 'Montant',
    key: 'montant',
    dataIndex: 'montant',
    render: (montant) => {
      return montant + '€'
    },
  },
  {
    title: 'Numéro',
    key: 'numero',
    dataIndex: 'numero',
  },
  {
    title: 'Tireur',
    key: 'tireur',
    dataIndex: 'tireur',
    render: (_, record) => {
      return record.tireurcheque?.nomtireurcheque
    },
  },
  {
    title: 'Banque',
    key: 'banque',
    render: (_, record) => {
      return record.societeByBanqueId?.raisonsociale + ' ' + record.societeByBanqueId?.lieu
    },
  },
]

const ChequesTable = ({ coproprietaireId }: { coproprietaireId: number | null }) => {
  const { data } = useQuery<{ cheques: D4_Partchequecoproprietaire[] }>(CHEQUES_QUERY, {
    skip: !coproprietaireId,
    variables: { id: coproprietaireId },
  })

  if (!data) {
    return null
  }
  const cheques: D4_Cheque[] = data.cheques.map((part) => part?.cheque ?? ({} as D4_Cheque))

  return (
    <Table pagination={{ pageSize: 3, position: ['bottomLeft'] }} size="small" columns={columns} dataSource={cheques} />
  )
}

export default ChequesTable
